import React, { useEffect, useState, useContext } from 'react';
import API from '../api';
import { AuthContext } from '../components/AuthContext';
import AdminLayout from '../components/AdminLayout';

const AdminCustomersPage = () => {
  const { user } = useContext(AuthContext);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);

  // Fetch customers
  useEffect(() => {
    if (!(user && user.role === 'admin')) return;
    setLoading(true); 
    setError(null);
    API.get('/auth/admin/customers')
      .then(res => setCustomers(res.data.customers))
      .catch(() => setError('Errore nel recupero dei clienti'))
      .finally(() => setLoading(false));
  }, [user]);

  // Expand customer
  const handleExpandCustomer = (userId) => {
    if (expandedRow && expandedRow.type === 'customer' && expandedRow.id === userId) {
      setExpandedRow(null);
      return;
    }
    setExpandedRow({ type: 'customer', id: userId });
  };

  return (
    <AdminLayout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ margin: 0 }}>Gestione Clienti</h2>
      </div>

      {loading ? (
        <div style={{ padding: 32, textAlign: 'center' }}>Caricamento...</div>
      ) : error ? (
        <div style={{ color: 'red', padding: 32, textAlign: 'center' }}>{error}</div>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>Nome</th>
              <th>Cognome</th>
              <th>Ruolo</th>
              <th>Data Registrazione</th>
            </tr>
          </thead>
          <tbody>
            {customers.map(customer => (
              <React.Fragment key={customer.id}>
                <tr
                  className={expandedRow && expandedRow.type === 'customer' && expandedRow.id === customer.id ? 'expanded' : ''}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleExpandCustomer(customer.id)}
                >
                  <td>{customer.id}</td>
                  <td>{customer.email}</td>
                  <td>{customer.name}</td>
                  <td>{customer.last_name}</td>
                  <td>{customer.role}</td>
                  <td>
                    {customer.created_at ? new Date(customer.created_at).toLocaleDateString('it-IT') : '-'}
                  </td>
                </tr>
                {expandedRow && expandedRow.type === 'customer' && expandedRow.id === customer.id && (
                  <tr>
                    <td colSpan={6} className="expand-row">
                      <div style={{ 
                        background: '#f8f9fa', 
                        padding: '16px', 
                        borderRadius: '8px',
                        border: '1px solid #dee2e6'
                      }}>
                        <h4 style={{ margin: '0 0 12px 0', color: '#495057' }}>Dettagli Cliente</h4>
                        <div style={{ 
                          fontSize: '12px', 
                          lineHeight: '1.4',
                          maxHeight: '300px',
                          overflowY: 'auto',
                          wordBreak: 'break-word'
                        }}>
                          {Object.entries(customer)
                            .filter(([k, v]) => v !== null && v !== '')
                            .map(([k, v]) => (
                              <div key={k} style={{ 
                                marginBottom: '4px',
                                padding: '4px 0',
                                borderBottom: '1px solid #eee'
                              }}>
                                <strong style={{ color: '#495057' }}>{k}:</strong> 
                                <span style={{ marginLeft: '8px', color: '#6c757d' }}>
                                  {typeof v === 'string' && v.length > 100 
                                    ? `${v.substring(0, 100)}...` 
                                    : v}
                                </span>
                              </div>
                            ))}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}
    </AdminLayout>
  );
};

export default AdminCustomersPage; 